import { QueuedWhileOfflineError } from '@/application/outbox/dispatch';
import { failureWords } from '@/shared/failure/failure';
import { strings } from '@/shared/strings';
import { toast } from '@/ui/primitives/toastStore';

/**
 * How a failed command is reported. Section 9.
 *
 * A command that is safely queued reads as done: the technician is moved on and
 * told it will sync. Keeping them on the job screen with "Failed to fetch"
 * would make them tap it again, and then stop trusting the system, which is the
 * failure section 9 opens by describing.
 *
 * A refusal is a genuine error and stays where it is, with the server's words.
 */
export function reportCommandFailure(
  error: Error,
  onQueued: () => void,
): void {
  if (error instanceof QueuedWhileOfflineError) {
    toast(strings.sync.queued);
    onQueued();
    return;
  }
  toast(failureWords(error), { tone: 'error' });
}
